import * as React from "react";
import { CircularProgress, Menu, MenuItem } from "@mui/material";
import toast from "react-hot-toast";
import "./BrandFontActionMenu.scss";
import SubMenuThreeDotIcon from "../../../../components/icons/SubMenuThreeDotIcon";

interface BrandFontActionMenuProps {
  fontId: string;
  status: string;
  onAction?: (fontId: string, action: string) => void;
  canEdit: boolean;
}

const BrandFontActionMenu: React.FC<BrandFontActionMenuProps> = ({
  fontId,
  status,
  onAction,
  canEdit,
}) => {
  const [state, setState] = React.useState<any>({
    isLoading: false,
    anchorEl: null,
  });

  const open = Boolean(state?.anchorEl);

  const handleClick = (event: any) => {
    setState({ ...state, anchorEl: event.currentTarget });
  };

  const handleClose = () => {
    setState({ ...state, anchorEl: null });
  };

  const handleActionClick = (action: string) => {
    handleClose();
    if (!canEdit) {
      toast.error("Permission denied.");
      return;
    }
    if (onAction) onAction(fontId, action);
  };

  return (
    <>
      <div
        className="brand-font-menu-icon"
        onClick={handleClick}
        aria-controls={open ? "brand-font-action-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        {state?.isLoading ? (
          <CircularProgress
            style={{ width: 15, height: 15 }}
            className="circular-progress-action-icon"
          />
        ) : (
          <SubMenuThreeDotIcon />
        )}
      </div>

      <Menu
        id="brand-font-action-menu"
        anchorEl={state?.anchorEl}
        open={open}
        onClose={handleClose}
        className="brand-font-menu"
        autoFocus={false}
      >
        {/* <MenuItem
          onClick={() =>
            handleActionClick(status === "active" ? "deactivate" : "activate")
          }
        >
          {status === "active" ? "Deactivate" : "Activate"}
        </MenuItem> */}

        <MenuItem onClick={() => handleActionClick("delete")}>
          Delete font
        </MenuItem>
      </Menu>
    </>
  );
};

export default BrandFontActionMenu;